<template>
  <div v-if="!editing.isEditing" class="editable label form-control">
    <slot :value="editingValue">{{editingValue}}</slot>
  </div>
  <div v-else class="editable">
    <slot name="input" :editing="editing.value">
      <blumar-decimal-input v-if="type === 'decimal'" v-model="editingValue" v-bind="$attrs" v-on="$listeners" class="editable decimal"/>
      <blumar-date-input v-else-if="type === 'date'" v-model="editingValue" v-bind="$attrs" v-on="$listeners" class="editable" size="md"/>
      <b-input v-else v-model="editingValue" v-bind="$attrs" v-on="$listeners" class="editable" v-mask="mask || ''"/>
    </slot>
  </div>
</template>

<script>
import BlumarDecimalInput from '../../shared/BlumarDecimalInput.vue';
import { get, set } from 'lodash';
import BlumarDateInput from '../../shared/BlumarDateInput.vue';

export default {
  components: { BlumarDecimalInput, BlumarDateInput },
  inject: ['editing'],
  props: ['name', 'type', 'mask'],
  computed: {
    editingValue: {
      get() {
        return get(this.editing.value, this.name);
      },
      set(value) {
        set(this.editing.value, this.name, value);
      },
    }
  },
}
</script>

<style scoped>
.editable {
  display: block;
  width: 100%;
  height: unset;
  padding: 0 5px;
  box-sizing: border-box;
}

.label {
  border: none;
  padding: 1px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/os/accountability/Editable.vue